import unescapedText from 'I18n/utils/unescapedText';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UIRouterNavButton from 'ui-addon-react-router-dom/UIRouterNavButton';
import { getStorefrontRoute } from '../../utils/urls';
import { useRouteOfferingType } from '../../common/hooks/useRouteOfferingType';
import { jsx as _jsx } from "react/jsx-runtime";
export default function NotFoundError() {
  const offeringType = useRouteOfferingType();
  return /*#__PURE__*/_jsx(UIErrorMessage, {
    type: "notFound",
    title: unescapedText('marketplace-assets-ui.error.notFound.title'),
    children: /*#__PURE__*/_jsx(UIRouterNavButton, {
      className: "m-top-4",
      exact: true,
      to: getStorefrontRoute(offeringType),
      use: "tertiary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.error.notFound.button"
      })
    })
  });
}